import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Domestic from './Domestic';
import Abroad from './Abroad';
import store from '../../../../../store/store';
import HTTP from '../../../../../script/service';
import './index.scss';

const RealNameCom = ({ cert, onCancel, onSuccess, base }) => {
  const { uid, realAuthData } = base;
  const [curCert, setCurCert] = useState(cert);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (realAuthData?.isTrigger) {
      store.dispatch({
        type: 'real_auth_data',
        data: { realAuthData: { ...realAuthData, isTrigger: false } },
      });
      if (realAuthData?.isMsg && realAuthData?.certOperateType == 2) {
        getMsgRealInfo();
      } else if (
        realAuthData?.userCertStatus == 0 ||
        realAuthData?.userCertStatus == 2
      ) {
        getRealStatus();
      } else if (
        (realAuthData?.userCertStatus == 3 ||
          realAuthData?.userCertStatus == 4) &&
        !realAuthData?.userCertInfoVo
      ) {
        getRealInfo();
      } else {
        setCurCert(realAuthData || {});
      }
    }
  }, [realAuthData]);

  //手动实名认证触发
  const getRealInfo = () => {
    let params = {
      uid: uid,
    };
    HTTP._get_user_real_info(params).then((res) => {
      if (res.code === 200) {
        let userCertInfoVo = res?.data;
        store.dispatch({
          type: 'real_auth_data',
          data: {
            realAuthData: { ...realAuthData, userCertInfoVo, isTrigger: true },
          },
        });
      }
    });
  };
  //手动实名认证触发
  const getRealStatus = () => {
    let params = {
      uid: uid,
    };
    HTTP._get_user_real_status(params).then((res) => {
      if (res.code === 200) {
        store.dispatch({
          type: 'real_auth_data',
          data: { realAuthData: { ...res?.data, isTrigger: true } },
        });
      }
    });
  };

  const onRealNameCancel = () => {
    store.dispatch({ type: 'real_auth_data', data: { realAuthData: null } });
    onCancel && onCancel();
  };

  //私聊触发
  const getMsgRealInfo = () => {
    let params = {
      uid: uid,
    };
    HTTP._get_user_msg_real_info(params).then((res) => {
      if (res.code === 200) {
        let userCertInfoVo = res?.data;
        store.dispatch({
          type: 'real_auth_data',
          data: {
            realAuthData: {
              ...realAuthData,
              userCertInfoVo,
              isTrigger: true,
              isMsg: false,
            },
          },
        });
      }
    });
  };
  if (curCert?.areaType === 0) {
    // 国内
    return (
      <Domestic
        cert={curCert}
        onCancel={onRealNameCancel}
        onSuccess={onSuccess}
      />
    );
  } else if (curCert?.areaType === 1) {
    // 国外
    return (
      <Abroad
        cert={curCert}
        onCancel={onRealNameCancel}
        onSuccess={onSuccess}
      />
    );
  }
  return null;
};

export default connect((store) => ({ base: store }))(RealNameCom);
